import CourseDetailsCard from './CourseDetailsCard';

export default CourseDetailsCard;
